
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pengelolaan-kinerja-ps/pegawai/perencanaan/ajukan",
      function () {
        return require("private-next-pages/pengelolaan-kinerja-ps/pegawai/perencanaan/ajukan.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pengelolaan-kinerja-ps/pegawai/perencanaan/ajukan"])
      });
    }
  